import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class RepSection extends Mappeable {

    idTypeStructureReportPk: number;
    txtName: string;
    isObligatory: boolean;
    iconSection: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtName: this.txtName,
            iconSection: this.iconSection,
            mrkActive: this.mrkActive,
            isObligatory: this.isObligatory ? this.isObligatory : false
        }
    }


}
